import { useDark } from "./useNavTheme";

const sizeClasses = {
  sm: "h-8 w-8",
  md: "h-9 w-9",
  lg: "h-10 w-10",
  xl: "h-11 w-11",
};

export const IconPill = ({
  size = "lg",
  className = "",
  children,
  onClick,
  active,
  ...rest
}) => {
  const dark = useDark();

  const handleClick = (e) => {
    try {
      navigator.vibrate?.(10);
    } catch {}
    onClick?.(e);
  };

  return (
    <button
      onClick={handleClick}
      className={[
        "relative group inline-flex items-center justify-center",
        "rounded-lg border transition-all duration-200 ease-out",
        "focus:outline-none cursor-pointer",
        sizeClasses[size] || sizeClasses.lg,
        active
          ? "bg-velBlue/15 border-velBlue/30"
          : "bg-transparent border-transparent hover:bg-btnHover hover:border-velBlueSecond/25",
        className,
      ].join(" ")}
      {...rest}
    >
      <span className="relative z-10">{children}</span>
    </button>
  );
};

export default IconPill;
